import React, { useEffect, useState } from 'react';

import { Grid, Typography, List, ListItem, Divider, Link } from '@material-ui/core';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

import {
  BACKGROUND_COLOR,
  COLOR_PRIMARY_LIGHT,
  COLOR_PRIMARY_DARK,
  COLOR_ACCENT_1,
  COLOR_ACCENT_2,
} from 'src/const';
import { callApi } from 'src/core/callApi';
import KeyMetricsBigMarketCard from './cards/BigMarketKeyMetrics';

const SingleBigMarket = () => {
  const marketName = window.location.href.split('/').reverse()[0];

  const [market, setMarket] = useState<string[] | null>(null);
  const [monthlyRev, setMonthlyRev] = useState<null | { date: string; revenue: number }[]>(null);
  const [monthlyOccRate, setMonthlyOccRate] = useState<null | { date: string; revenue: number }[]>(
    null
  );
  const [monthlyAdr, setMonthlyAdr] = useState<null | { date: string; revenue: number }[]>(null);

  const [isAuthorized, setIsAuthorized] = useState<boolean>(true);

  const getBigMarkets = async () => {
    const url = 'https://3lgkyxa85a.execute-api.us-east-2.amazonaws.com/default/getBigMarkets';
    const queryParamsConfig = { queryParams: { marketName: marketName } };
    try {
      const result: { message: any[] | string } = await callApi(url, queryParamsConfig, true);
      console.log('Res >> ', result);
      if (!Array.isArray(result?.message)) {
        setIsAuthorized(false);
        return;
      }
      setMarket(result.message[0]);
      return;
    } catch (err) {
      console.log('Error: ', err);
    }
  };

  useEffect(() => {
    getBigMarkets();
  }, []);

  useEffect(() => {
    if (market) {
      const monthlyRevenue = JSON.parse(market[4]);
      const monthlyOccRate = JSON.parse(market[5]);
      const monthlyAdr = JSON.parse(market[6]);
      setMonthlyRev(monthlyRevenue);
      setMonthlyOccRate(monthlyAdr);
      setMonthlyAdr(monthlyOccRate);
    }
  }, [market]);

  if (!isAuthorized) {
    return (
      <Grid
        container
        direction="column"
        justifyContent="space-between"
        spacing={4}
        style={{ padding: '40px' }}
      >
        <Typography variant="h1">Unauthorized !</Typography>
      </Grid>
    );
  }

  return (
    <Grid
      container
      direction="column"
      justifyContent="space-between"
      spacing={4}
      style={{ padding: '40px' }}
    >
      <Grid item>
        <Typography variant="h5" style={{ marginBottom: 10 }}>
          {market && market[0]}
        </Typography>

        <Divider />

        {!market && <Typography variant="h5">Loading ...</Typography>}
      </Grid>

      <Grid item>
        <List>
          {market && (
            <>
              <ListItem>
                <Typography>
                  <Link target="_blank" style={{ textTransform: 'capitalize', fontSize: 24 }}>
                    Total Number Of Listings: <span style={{ color: '#000' }}>{market[8]}</span>
                  </Link>
                </Typography>
              </ListItem>
            </>
          )}
        </List>
      </Grid>

      <Grid item>
        {monthlyRev && (
          <KeyMetricsBigMarketCard
            title="revenue"
            color={COLOR_PRIMARY_LIGHT}
            keyMetricsVal={monthlyRev}
          />
        )}
        <br />
        {monthlyOccRate && (
          <KeyMetricsBigMarketCard
            title="occupancy_rate"
            color={COLOR_ACCENT_1}
            keyMetricsVal={monthlyOccRate}
          />
        )}
        <br />
        {monthlyAdr && (
          <KeyMetricsBigMarketCard title="adr" color={COLOR_ACCENT_2} keyMetricsVal={monthlyAdr} />
        )}
      </Grid>
    </Grid>
  );
};

export default SingleBigMarket;
